<div class="dashboard-container" *appRole="['Dashboard.Clientes']">
  <div class="welcome-card mat-elevation-z4">
    <div class="welcome-header">
      <h1>¡Bienvenido/a, {{usuarioDto.name}}!</h1>
      <p class="welcome-message">Estamos encantados de tenerte aquí. Utiliza las herramientas del sistema para gestionar tus tareas de manera eficiente.</p>
    </div>
  </div>
</div>
